import { render, staticRenderFns } from "./chart4.vue?vue&type=template&id=6db5c65a&scoped=true"
import script from "./chart4.vue?vue&type=script&lang=js"
export * from "./chart4.vue?vue&type=script&lang=js"
import style0 from "./chart4.vue?vue&type=style&index=0&id=6db5c65a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db5c65a",
  null
  
)

export default component.exports